module.exports = __webpack_public_path__ + "img/walking-profile.0b0e9d9a.svg";